import { render, staticRenderFns } from "./CollectionsEngagement.vue?vue&type=template&id=9eb870f0"
import script from "./CollectionsEngagement.vue?vue&type=script&lang=js"
export * from "./CollectionsEngagement.vue?vue&type=script&lang=js"
import style0 from "./CollectionsEngagement.vue?vue&type=style&index=0&id=9eb870f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports